import { render, staticRenderFns } from "./Diamond.vue?vue&type=template&id=d2d9c444&scoped=true&"
var script = {}
import style0 from "./Diamond.vue?vue&type=style&index=0&id=d2d9c444&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2d9c444",
  null
  
)

export default component.exports